import { render, staticRenderFns } from "./JudgesDetail.vue?vue&type=template&id=611c2060&scoped=true&"
import script from "./JudgesDetail.vue?vue&type=script&lang=js&"
export * from "./JudgesDetail.vue?vue&type=script&lang=js&"
import style0 from "./JudgesDetail.vue?vue&type=style&index=0&id=611c2060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c2060",
  null
  
)

export default component.exports